<script lang="ts">
    import { browser } from '$app/environment';
    import StaticComponents from '$src/lib/components/StaticComponents/StaticComponents.svelte';
    import Favicon from '$src/lib/components/Favicon/Favicon.svelte';
    import OverlayContext from '$src/lib/layouts/overlays/OverlayContext.svelte';
    import TrackingManager from '$src/lib/components/TrackingManager/TrackingManager.svelte';
    import EventsManager from '$src/lib/components/EventsManager/EventsManager.svelte';
    import RedirectsManager from '$src/lib/components/RedirectsManager/RedirectsManager.svelte';
    import RouteGuardManager from '$src/lib/components/RouteGuardManager/RouteGuardManager.svelte';
    import CometDManager from '$src/lib/components/CometDManager/CometDManager.svelte';
    import GatekeeperManager from '$src/lib/components/Gatekeeper/GatekeeperManager.svelte';
    import FlagUserNotOnMaster from '$src/lib/components/FlagUserNotOnMaster/FlagUserNotOnMaster.svelte';
    import RedDotNotificationManager from '$src/lib/components/EventsManager/RedDotNotificationManager.svelte';
    import NativeBridgeManager from '$src/lib/components/NativeBridgeManager/NativeBridgeManager.svelte';
    import SessionTouch from '$src/lib/components/SessionTouch/SessionTouch.svelte';

    export let data;
    // initial value
    const { authBootstrap } = data;

    let gatekeeperInitiated = false;
</script>

{#if browser && !data.isCasumoProd && Boolean(data.cfSpineOverride)}
    <FlagUserNotOnMaster />
{/if}
<Favicon />
<TrackingManager />
<NativeBridgeManager {gatekeeperInitiated} />
<EventsManager />
<RouteGuardManager />
<CometDManager />
<RedirectsManager />
<RedDotNotificationManager />
<GatekeeperManager {authBootstrap} onGatekeeperInitiated={() => (gatekeeperInitiated = true)} />
<SessionTouch />

<OverlayContext>
    <slot />
</OverlayContext>

<StaticComponents />
